import React from "react";
import HeaderPasos from "../../../componentsUI/estructura/headerPasos/headerPasos.js";

import Dashboard26 from "../cuenta/dashboard.js";
import TabsAdministracionModulo from "../../administracion/tabsTemplate/tabsTemplate.js";

import Error404 from "../../../componentsUI/modulo404/modulo404.js";


const pasosCuenta = [
  {
    id: "tienda",
    label: "Configurar Tienda",
    component: <Dashboard26/>,
  },
  {
    id: "parametros",
    label: "Configurar Parametros",
   component: <TabsAdministracionModulo/>,
  },
  {
    id: "usuarios",
    label: "Configurar Usuarios",
  component: <Error404/>,
  },
 
];

export default function TemplateCuenta() {
  return (
    <HeaderPasos
      titulo="Cuenta"
      pasos={pasosCuenta}
      pasoInicial="tienda"
    />
  );
}
